var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2, _rect7, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCourseCount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 63,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.941,
  height: 44.236,
  x: 47.059,
  y: 18.096,
  fill: "#DDD",
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16.941,
  height: 52.706,
  x: 38.589,
  y: 9.625,
  fill: "#B9B9B9",
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 47.059,
  height: 61.648,
  y: 0.684,
  fill: "#FFE040",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M0 4.684a4 4 0 0 1 4-4h39.06a4 4 0 0 1 4 4v.235H0z"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 20.706,
  height: 2.824,
  x: 16.469,
  y: 33.625,
  fill: "#656565",
  rx: 1.412
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 24.941,
  height: 2.824,
  x: 16.469,
  y: 42.566,
  fill: "#656565",
  rx: 1.412
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 17.412,
  height: 2.824,
  x: 16.469,
  y: 51.508,
  fill: "#656565",
  rx: 1.412
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  d: "M9.755 37.86h-.004a1.78 1.78 0 0 1-1.43-.73l-1.49-2.052a1.28 1.28 0 0 1 .281-1.786 1.274 1.274 0 0 1 1.783.28l.863 1.19 2.526-3.44a1.274 1.274 0 0 1 1.784-.271 1.28 1.28 0 0 1 .27 1.788l-3.155 4.298a1.78 1.78 0 0 1-1.428.723M9.755 46.802H9.75a1.78 1.78 0 0 1-1.43-.731l-1.49-2.051a1.28 1.28 0 0 1 .281-1.787 1.274 1.274 0 0 1 1.782.28l.864 1.19 2.526-3.44a1.274 1.274 0 0 1 1.784-.271 1.28 1.28 0 0 1 .27 1.788l-3.155 4.298a1.78 1.78 0 0 1-1.428.724M9.755 55.743H9.75a1.78 1.78 0 0 1-1.43-.731l-1.49-2.051a1.28 1.28 0 0 1 .281-1.787 1.274 1.274 0 0 1 1.782.281l.864 1.19 2.526-3.44a1.274 1.274 0 0 1 1.784-.272 1.28 1.28 0 0 1 .27 1.788l-3.155 4.298a1.78 1.78 0 0 1-1.428.724"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 35.116,
  height: 17.948,
  x: 6.243,
  y: 9.267,
  fill: "#F9FAFC",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB2B42",
  d: "M24.19 13.17a5.462 5.462 0 1 0 0 10.924 5.462 5.462 0 0 0 0-10.925m-1.525 3.13 4.174 2.233-4.174 2.231z"
})));
export default SvgCourseCount;